import React from "react";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

// Register Chart.js elements
Chart.register(ArcElement, Tooltip, Legend);

const makers = [
  {
    name: "Sunita Pawar",
    district: "Satara, Maharashtra",
    skill: "Pickle & Preserves Entrepreneur",
    badge: "🌶️ SHG Leader",
    bio: "Started with a small SHG and now exports homemade pickles and masalas to 5 states under her brand 'Swaadghar'.",
    img: "https://via.placeholder.com/200x200/FF66B2/000000?text=Sunita",
    stats: {
      labels: ["Production", "Sales", "Social Reach"],
      data: [60, 25, 15],
    },
    socials: {
      facebook: "https://facebook.com/",
      instagram: "https://instagram.com/",
      linkedin: "https://linkedin.com/",
    },
  },
  {
    name: "Aarti Shinde",
    district: "Nashik, Maharashtra",
    skill: "Organic Farming & Millet Products",
    badge: "🌾 Agri Innovator",
    bio: "Empowering 200+ rural women through millet-based food processing and organic farming cooperatives.",
    img: "https://via.placeholder.com/200x200/FF99CC/000000?text=Aarti",
    stats: {
      labels: ["Production", "Sales", "Social Reach"],
      data: [45, 35, 20],
    },
    socials: {
      facebook: "https://facebook.com/",
      instagram: "https://instagram.com/",
      linkedin: "https://linkedin.com/",
    },
  },
  {
    name: "Farzana Sheikh",
    district: "Aurangabad, Maharashtra",
    skill: "Handmade Soap & Herbal Skincare",
    badge: "🧼 Beautypreneur",
    bio: "Runs an eco-friendly skincare brand using local herbs, promoting zero-plastic packaging and sustainable sourcing.",
    img: "https://via.placeholder.com/200x200/FF80AA/000000?text=Farzana",
    stats: {
      labels: ["Production", "Sales", "Social Reach"],
      data: [40, 40, 20],
    },
    socials: {
      facebook: "https://facebook.com/",
      instagram: "https://instagram.com/",
      linkedin: "https://linkedin.com/",
    },
  },
];

export default function MahilaMandiMeetTheMaker() {
  return (
    <div className="min-h-screen bg-gray-900 text-pink-200 flex flex-col items-center p-4">
      {/* Header */}
      <header className="text-center mb-6">
        <h1 className="text-3xl font-bold text-pink-400 mb-1">
          🌸 Meet the Makers
        </h1>
        <p className="text-sm text-pink-300">
          Inspiring Women Entrepreneurs from across Maharashtra
        </p>
      </header>

      {/* Makers Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 w-full max-w-6xl">
        {makers.map((maker, idx) => (
          <div
            key={idx}
            className="bg-gray-800 border border-pink-600 rounded-2xl p-5 shadow-lg hover:shadow-pink-400/40 transition-all duration-300 flex flex-col items-center"
          >
            {/* Maker Image */}
            <img
              src={maker.img}
              alt={maker.name}
              className="w-28 h-28 object-cover rounded-full border-4 border-pink-500 mb-3"
            />

            {/* Maker Info */}
            <h2 className="text-xl font-semibold text-pink-300">
              {maker.name}
            </h2>
            <p className="text-sm text-gray-300 flex items-center justify-center gap-1">
              <i className="fa-solid fa-location-dot text-pink-400"></i>{" "}
              {maker.district}
            </p>
            <span className="mt-1 text-xs bg-pink-700 text-white px-3 py-1 rounded-full shadow-md">
              {maker.badge}
            </span>

            <p className="text-sm mt-3 text-gray-300">{maker.skill}</p>
            <p className="text-xs mt-2 text-gray-400">{maker.bio}</p>

            {/* Chart Section */}
            <div className="w-32 h-32 mt-4">
              <Doughnut
                data={{
                  labels: maker.stats.labels,
                  datasets: [
                    {
                      data: maker.stats.data,
                      backgroundColor: ["#ec4899", "#f472b6", "#f9a8d4"],
                      borderColor: "#1f2937",
                      borderWidth: 2,
                    },
                  ],
                }}
                options={{
                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                  cutout: "65%",
                }}
              />
            </div>
            <p className="text-xs mt-2 text-gray-400">
              <i className="fa-solid fa-chart-pie text-pink-400 mr-1"></i>
              Maker Activity Stats
            </p>

            {/* Social Links */}
            <div className="flex justify-center gap-5 mt-4">
              <a
                href={maker.socials.facebook}
                className="text-pink-300 hover:text-pink-500"
              >
                <i className="fab fa-facebook fa-lg"></i>
              </a>
              <a
                href={maker.socials.instagram}
                className="text-pink-300 hover:text-pink-500"
              >
                <i className="fab fa-instagram fa-lg"></i>
              </a>
              <a
                href={maker.socials.linkedin}
                className="text-pink-300 hover:text-pink-500"
              >
                <i className="fab fa-linkedin fa-lg"></i>
              </a>
            </div>

            {/* Footer note */}
            <div className="mt-3 border-t border-pink-600 pt-2 text-center">
              <p className="text-xs text-gray-400">
                <i className="fa-solid fa-award text-pink-400 mr-1"></i>
                Recognized by MSME / SHG networks
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <footer className="mt-8 text-center text-xs text-pink-400 opacity-70">
        © 2025 MahilaMandi | Empowering Women Makers of Maharashtra
      </footer>
    </div>
  );
}
